import { DataTypeSetStockByLocationType, FilterTypeSetStockByLocation } from "pages/Inventori/Transaction/SetStockByLocation/types"
import { useEffect, useState } from "react"
import { useApi } from "utils"

type DetailSetStockByLocationType = DataTypeSetStockByLocationType & {
  category_name: string
}

interface DataType {
  items: DetailSetStockByLocationType[]
  pagination_data: {
    total: number
    page: number
    size: number
    pages: number
  }
}

const cleanParams = (params: Record<string, any>) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== ""
    )
  )

export function useListDetailStockLocation(
  props: Partial<FilterTypeSetStockByLocation> = {}
) {
  const { page, limit, keyword, category_id, buy, sell, inv, build, location_id, zero_max, zero_min, zero_soh } = props

  const defaultValue: DataType = {
    items: [],
    pagination_data: {
      page: 1,
      pages: 1,
      size: 10,
      total: 0,
    },
  }

  const api = useApi()
  const [data, setData] = useState<DataType>(defaultValue)
  const [isLoading, setLoading] = useState(true)

  const params = cleanParams({
    page,
    limit,
    keyword,
    category_id,
    buy,
    sell,
    inv,
    build,
    location_id,
    zero_max,
    zero_min,
    zero_soh,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const res = await api.get("/product/list-product-minmax-loc-pivot", { params })
      setData(res.data.payload)
    } catch {
      setData(defaultValue)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)])

  return {
    data,
    isLoading,
    refetch: fetchData,
  }
}


